const settings = {
  advanced: 'Avancé',
  censoredWords: 'Mots censurés',
  general: 'Général',
  language: 'Langue',
  settings: 'Paramètres',
  timeZone: 'Fuseau horaire',
  timeZoneDevice: 'Identique à cet appareil',
};

export default settings;
